// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__MmQOy","left":"StickyBox_left__2VXe8","right":"StickyBox_right__3c99U"};